module.exports = __webpack_public_path__ + "static/manes-fbab883ecbe6e3146db6b8f274fcc0ea.jpeg";